import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import resources from 'app/store/resources';
// import Notification from 'app/containers/Notifications/Notification/Notification.jsx'
import Notification from 'app/containers/Notifications/Notification/Notification';
import Widget from 'app/components/Widget/Widget.jsx';
import PaginatedComponent from 'app/components/PaginatedComponent/PaginatedComponent.jsx';
import { getStatusRequest } from 'app/store/resources/utils/getStatusRequest';
import { getResources } from 'app/store/selectors/getResources';
import { activeUserSelector } from 'app/store/selectors/user';
export default function NotificationsList() {
    const userId = useSelector(activeUserSelector);
    const [isLoading, setIsLoading] = useState(false);
    const request = useSelector((state) => { var _a; return (_a = state.notifications.requests) === null || _a === void 0 ? void 0 : _a.fetchUserNotifications; });
    // TO DO : type notification
    const [notifications, setNotifications] = useState([]);
    const [count, setCount] = useState(0);
    useEffect(() => {
        const load = getStatusRequest('notifications', 'fetchUserNotifications');
        setIsLoading(load.pending);
        if (request) {
            setNotifications(Object.values(getResources(undefined, 'notifications.requests.fetchUserNotifications')));
            setCount(request.count);
        }
    }, [request]);
    function onRequestNeeded(pageSize, currentPage) {
        const params = {
            queries: {
                page_size: pageSize,
                page: currentPage,
            },
        };
        resources.notifications.fetchUserNotifications({ id: userId }, undefined, {
            params,
        });
    }
    // TO DO : type notification
    function onClickNotif(notification) {
        const _notif = Object.assign(Object.assign({}, notification), { unread: false });
        resources.notifications.update(_notif);
    }
    function renderNotifications() {
        if (!notifications || !notifications.length)
            return _jsx("div", { children: "No Notifications" });
        return (_jsx("div", { style: { flex: 1 }, children: notifications.map((notif, index) => (_jsx("div", { children: _jsx(Notification, { notification: notif, isLastNotif: index === notifications.length - 1, onClickNotif: onClickNotif }) }, notif.id))) }));
    }
    return (_jsx(Widget, { style: { margin: '0 auto', height: '100%', width: '100%', overflowY: 'auto' }, children: _jsx(PaginatedComponent, { count: count, isLoading: isLoading, renderChildren: renderNotifications, onRequestNeeded: onRequestNeeded }) }));
}
